export const environment = {
    production: false,
    rolesDisabled: false,
    API_URL: `https://api.dev.realtbox.in`,
    PRIVATE_KEY : 'XGgsQthLzMQvTo2hIXltdVt3O1JiPgi8',
    MAPS_KEY: 'AIzaSyCrfbDrpH9weSNGdtwKKfIP0RSjz6hSTRs'
};

